const ErrorMessages = {
    required: "必須項目です",
    email: "正しいメールアドレスの形式でご入力ください",
    emailCount: "100文字以内で入力",
    password: "8文字以上で入力",
    passwordCount: "100文字以内で入力",
    phoneNumber: "正しい電話番号の形式でご入力ください",
    clientName: "100文字以内で入力",
    companyName: "200文字以内で入力",
    clientNameKana: "100文字以内の『ひらがな』で入力",
    title: "100文字以内で入力",
    url: "URLの形式が間違っています。 例：https://example.com",
    urlCount: "200文字以内で入力",
    host: "企業ドメインの形式が間違っています。 例：example.com",
    hostCount: "200文字以内で入力",
    postalCode: "正しい郵便番号の形式でご入力ください",
    place: "500文字以内で入力",
    representativeName: "100文字以内で入力",
    capitalStock: "数字で入力ください",
    capitalStockCount: "15桁以内で入力",
    introduction: "5000文字以内で入力",
    accordingCompanyName: "200文字以内で入力",
    accordingCompanyPostalCode: "正しい郵便番号の形式でご入力ください",
    accordingCompanyAddress: "500文字以内で入力",
    messageText: "5000文字以内で入力",
    messageTextrequired: " ",
    projectName: "40文字以内で入力",
    projectDescription: "5000文字以内で入力",
    projectBackground: "5000文字以内で入力",
    projectPreferentialExperience: "5000文字以内で入力",
    customerName: "100文字以内で入力",
    customerNameKana: "100文字以内の『ひらがな』で入力",
    pr: "5000文字以内で入力",
    dateAt: "正しい年月日で入力(YYYY/MM/DD)",
    jobCareerDescription: "1000文字以内で入力",
    dutySummary: "5000文字以内で入力",
    requestedCondition: "1000文字以内で入力",
    catchphrase: "25文字以内で入力",
    requirements: "200文字以内で入力",
    academicBackgrounds: "200文字以内で入力",
    jobCareerOccupations: "職種は1つだけ選択してください",
    confirmPass: "パスワードが違います",
    confirmEmail: "メールアドレスが違います",
    privacy: "利用規約に同意が必要です",
    query: "100文字以内で入力",
    emailInText:
        "チャットルーム内での、メールアドレス、電話番号の交換は禁止されています。",
    phoneNumberInText:
        "チャットルーム内での、メールアドレス、電話番号の交換は禁止されています。",
    jobCareerPost: `100文字以内で入力`,
    number: "半角数字で入力してください",
    nonZero: "数値を入力してください",
    int: "半角数字、整数で入力してください",
    withholdingTaxRate: "少数2桁までで入力してください",
    contractDefaltText: "500文字以内で入力",
    contractDefaltInt: "10,000,000,000以内で入力",
    invoiceUnit: "10文字以内で入力",
    customerBillingAddress: "500文字以内で入力",
    payeeInfo: "100文字以内で入力",
    adminMemo: "5000文字以内で入力",
    interviewMemo: "5000文字以内で入力",
    achievementReward: "500文字以内で入力",
};

const Regex = {
    email:
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    password: /[!-~]{8,}$/,
    phoneNumber001: /^0\d\d{4}\d{4}$/,
    phoneNumber002: /^(050|070|080|090)\d{4}\d{4}$/,
    phoneNumber003: /^0120\d{3}\d{3}$/,
    url001: /^(https?)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/,
    url002: /^(http?)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/,
    host: /^([-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/,
    hostHttps: /^(https?)(:\/\/.*)$/,
    postalCode: /^\d{7}$/,
    capitalStock: /^[1-9]\d*$/,
    accordingCompanyPostalCode: /^\d{7}$/,
    dateAt: /^(\d{4})\/(\d{2})\/(\d{2})$/, // ToDo : 簡易対応、桁数のみ
    emailStringInText: /^.*メールアドレス.*/,
    phoneNumberStringInText: /^.*電話番号.*/,
    emailInText:
        /[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/,
    phoneNumber001InText: /0\d\d{4}\d{4}/,
    phoneNumber002InText: /(050|070|080|090)\d{4}\d{4}/,
    phoneNumber003InText: /0120\d{3}\d{3}/,
    phoneNumber004InText: /0\d{2,3}-\d{1,4}-\d{4}/,
    number: /^[-]?[0-9]+(\.[0-9]+)?$/,
    int: /^[0-9]+$/,
    withholdingTaxRate: /^([1-9][0-9]?|0)(\.[0-9]{1,2})?$/,
};

const isHiragana = (str: any): boolean => {
    str = str == null ? "" : str;
    if (str.match(/^[ぁ-んー　 ]*$/)) {
        // 後ろの文字は全角スペース及び半角スペースです。
        return true;
    } else {
        return false;
    }
};

export const required = (value: any) =>
    value || typeof value === "number" ? undefined : ErrorMessages.required;

export const requiredForMultiSelect = (value: any) => {
    if (value.length === 0) {
        return ErrorMessages.required;
    }
    return undefined;
};

export const requiredSelect = (value: any) =>
    parseInt(value, 10) === 0 ? ErrorMessages.required : undefined;

export const email = (value: any) =>
    value && !Regex.email.test(value) ? ErrorMessages.email : undefined;

export const emailCount = (value: any) =>
    value && value.length > 100 ? ErrorMessages.emailCount : undefined;

export const password = (value: any) =>
    value && !Regex.password.test(value) ? ErrorMessages.password : undefined;

export const passwordCount = (value: any) =>
    value && value.length > 100 ? ErrorMessages.passwordCount : undefined;

export const phoneNumber = (value: any) => {
    if (!value) {
        return undefined;
    } // 未入力時はエラーを返さない (required バリデーションで対応)

    // 半角数字のみかつ10~13桁の範囲をチェック
    if (!/^\d{10,13}$/.test(value)) {
        return ErrorMessages.phoneNumber;
    }

    return undefined;
};

export const clientName = (value: any) =>
    value && value.length > 100 ? ErrorMessages.clientName : undefined;

export const companyName = (value: any) =>
    value && value.length > 200 ? ErrorMessages.companyName : undefined;

export const jobCareerPost = (value: any) =>
    value && value.length > 100 ? ErrorMessages.jobCareerPost : undefined;

export const clientNameKana = (value: any) =>
    (value && value.length > 100) || !isHiragana(value)
        ? ErrorMessages.clientNameKana
        : undefined;

export const title = (value: any) =>
    value && value.length > 100 ? ErrorMessages.title : undefined;

export const url = (value: any) =>
    value && !Regex.url001.test(value) && !Regex.url002.test(value)
        ? ErrorMessages.url
        : undefined;

export const urlCount = (value: any) =>
    value && value.length > 200 ? ErrorMessages.urlCount : undefined;

export const host = (value: any) =>
    (value && !Regex.host.test(value)) || Regex.hostHttps.test(value)
        ? ErrorMessages.host
        : undefined;

export const hostCount = (value: any) =>
    value && value.length > 200 ? ErrorMessages.hostCount : undefined;

export const postalCode = (value: any) =>
    value && !Regex.postalCode.test(value) ? ErrorMessages.postalCode : undefined;

export const place = (value: any) =>
    value && value.length > 500 ? ErrorMessages.place : undefined;

export const capitalStock = (value: any) =>
    value && !Regex.capitalStock.test(value)
        ? ErrorMessages.capitalStock
        : undefined;

export const capitalStockCount = (value: any) =>
    value && value.length > 15 ? ErrorMessages.capitalStockCount : undefined;

export const representativeName = (value: any) =>
    value && value.length > 100 ? ErrorMessages.representativeName : undefined;

export const introduction = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.introduction : undefined;

export const accordingCompanyName = (value: any) =>
    value && value.length > 200 ? ErrorMessages.accordingCompanyName : undefined;

export const accordingCompanyPostalCode = (value: any) =>
    value && !Regex.accordingCompanyPostalCode.test(value)
        ? ErrorMessages.accordingCompanyPostalCode
        : undefined;

export const accordingCompanyAddress = (value: any) =>
    value && value.length > 500
        ? ErrorMessages.accordingCompanyAddress
        : undefined;

export const messageText = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.messageText : undefined;

export const messageTextrequired = (value: any) =>
    value || typeof value === "number"
        ? undefined
        : ErrorMessages.messageTextrequired;

export const projectName = (value: any) =>
    value && value.length > 40 ? ErrorMessages.projectName : undefined;

export const projectDescription = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.projectDescription : undefined;

export const projectPreferentialExperience = (value: any) =>
    value && value.length > 5000
        ? ErrorMessages.projectPreferentialExperience
        : undefined;

export const projectBackground = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.projectBackground : undefined;

export const customerName = (value: any) =>
    value && value.length > 100 ? ErrorMessages.customerName : undefined;

export const customerNameKana = (value: any) =>
    (value && value.length > 100) || !isHiragana(value)
        ? ErrorMessages.customerNameKana
        : undefined;

export const pr = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.pr : undefined;

export const dateAt = (value: any) =>
    value && !Regex.dateAt.test(value) ? ErrorMessages.dateAt : undefined;

export const jobCareerDescription = (value: any) =>
    value && value.length > 1000 ? ErrorMessages.jobCareerDescription : undefined;

export const dutySummary = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.dutySummary : undefined;

export const requestedCondition = (value: any) =>
    value && value.length > 1000 ? ErrorMessages.requestedCondition : undefined;

export const catchphrase = (value: any) =>
    value && value.length > 25 ? ErrorMessages.catchphrase : undefined;

export const requirements = (value: any) =>
    value && value.length > 200 ? ErrorMessages.requirements : undefined;

export const academicBackgrounds = (value: any) =>
    value && value.length > 200 ? ErrorMessages.academicBackgrounds : undefined;

export const jobCareerOccupations = (value: any) =>
    value && value.length !== 1 ? ErrorMessages.jobCareerOccupations : undefined;

export const confirmPass = (value: any, values: any) =>
    value && value !== values.password ? ErrorMessages.confirmPass : undefined;

export const confirmEmail = (value: any, values: any) =>
    value && value !== values.email ? ErrorMessages.confirmEmail : undefined;

export const privacy = (value: any) =>
    value || typeof value === "number" ? undefined : ErrorMessages.privacy;

export const query = (value: any) =>
    value && value.length > 100 ? ErrorMessages.query : undefined;

export const number = (value: any) =>
    value && !Regex.number.test(value) ? ErrorMessages.number : undefined;

export const int = (value: any) =>
    value && !Regex.int.test(value) ? ErrorMessages.int : undefined;

export const withholdingTaxRate = (value: any) =>
    value && !Regex.withholdingTaxRate.test(value)
        ? ErrorMessages.int
        : undefined;

export const nonZero = (value: any) =>
    value && Number(value) === 0 ? ErrorMessages.nonZero : undefined;

// 使い方：https://qiita.com/102Design/items/ecb97ec6fbeb1b09a474
export const extendValidator = (text: any) => (func: any) =>
    func ? text : undefined;

export const emailInText = (value: any) =>
    value && Regex.emailInText.test(value)
        ? ErrorMessages.emailInText
        : undefined;

export const phoneNumberInText = (value: any) =>
    (value && Regex.phoneNumber001InText.test(value)) ||
    Regex.phoneNumber002InText.test(value) ||
    Regex.phoneNumber003InText.test(value) ||
    Regex.phoneNumber004InText.test(value)
        ? ErrorMessages.phoneNumberInText
        : undefined;

export const emailAndPhoneNumberInText = (value: any) =>
    (value && Regex.emailStringInText.test(value)) ||
    Regex.phoneNumberStringInText.test(value) ||
    Regex.emailInText.test(value) ||
    Regex.phoneNumber001InText.test(value) ||
    Regex.phoneNumber002InText.test(value) ||
    Regex.phoneNumber003InText.test(value) ||
    Regex.phoneNumber004InText.test(value)
        ? ErrorMessages.phoneNumberInText
        : undefined;

export const contractDefaltText = (value: any) =>
    value && value.length > 500 ? ErrorMessages.contractDefaltText : undefined;

export const contractDefaltInt = (value: any) =>
    value && value > 1000000000 ? ErrorMessages.contractDefaltInt : undefined;

export const invoiceUnit = (value: any) =>
    value && value.length > 10 ? ErrorMessages.invoiceUnit : undefined;

export const customerBillingAddress = (value: any) =>
    value && value.length > 500
        ? ErrorMessages.customerBillingAddress
        : undefined;

export const payeeInfo = (value: any) =>
    value && value.length > 100 ? ErrorMessages.payeeInfo : undefined;

export const adminMemo = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.adminMemo : undefined;

export const interviewMemo = (value: any) =>
    value && value.length > 5000 ? ErrorMessages.interviewMemo : undefined;

export const achievementReward = (value: any) =>
    value && value.lenght > 500 ? ErrorMessages.achievementReward : undefined;



// WEBPACK FOOTER //
// ./src/util/validation.ts